<script>
    export default {
        mounted() {
			$(this.$el).embed();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UiEmbed.vue